module.exports = __webpack_public_path__ + "img/login-laptop.ae4daf1f.png";